import React from 'react';

const TeamCardSkeleton = () => {
    return (
        <div className="team-card skeleton-card">
            {/* Header Section */}
            <div className="team-header">
                <div className="skeleton-text skeleton-title-short" />
                <div className="skeleton-icon-small" />
            </div>

            {/* Members Section */}
            <div className="team-members-section">
                <div className="skeleton-text skeleton-label" style={{ width: '80px', marginBottom: '8px' }} />
                <div className="team-members-avatars">
                    {[1, 2, 3, 4, 5].map((i) => (
                        <div key={i} className="member-avatar skeleton-avatar" />
                    ))}
                </div>
            </div>

            {/* Actions Section */}
            <div className="team-actions-section">
                <div className="skeleton-text skeleton-label" style={{ width: '60px', marginBottom: '8px' }} />
                <div className="actions-list">
                    <div className="action-item skeleton-action" />
                    <div className="action-item skeleton-action" />
                </div>
            </div>
        </div>
    );
};

export default TeamCardSkeleton;
